import React from "react";
import { Box, Typography } from "@mui/material";

export type MiddleSelectOption = {
  value: string;
  label: string;
  icon?: React.ReactNode;
};

export interface CustomMiddleSelectProps {
  label?: string;
  options: MiddleSelectOption[];
  value: string | null | undefined;
  onChange: (value: string) => void;
  width?: string;
  height?: number;
  size?: "sm" | "md" | "lg";
  marginBottom?: number;
}

const CustomMiddleSelect: React.FC<CustomMiddleSelectProps> = ({
  label,
  options,
  value,
  onChange,
  width = "100%",
  height,
  size = "md",
  marginBottom,
}) => {
  const selectedIndex = options.findIndex((opt) => opt.value === value);

  const paddingY = size === "sm" ? 0.75 : size === "lg" ? 1.5 : 1;
  const fontSize = size === "sm" ? 12 : size === "lg" ? 16 : 14;
  return (
    <Box sx={{ mb: marginBottom ?? 2, width }}>
      {label && (
        <Typography sx={{ fontSize: 12, fontWeight: 700, mb: 1 }}>
          {label}
        </Typography>
      )}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          p: "4px",
          height,
          boxSizing: "border-box",
          borderRadius: 3,
          bgcolor: "#F1F3F5",
          width: "100%",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "4px",
            bottom: "4px",
            left: `calc(${selectedIndex} * (100% - 8px) / ${options.length} + 4px)`,
            width: `calc((100% - 8px) / ${options.length})`,
            transition: "left 320ms cubic-bezier(0.22, 1, 0.36, 1)",
            bgcolor: "#fff",
            borderRadius: 2,
            boxShadow: "0px 1px 2px rgba(16,24,40,0.08)",
            border: "1px solid rgba(0,0,0,0.1)",
            pointerEvents: "none",
          }}
        />
        {options.map((opt) => {
          const selected = value === opt.value;
          return (
            <Box
              key={opt.value}
              component="button"
              type="button"
              onClick={() => onChange(opt.value)}
              sx={{
                position: "relative",
                flex: 1,
                minWidth: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.75,
                px: 1,
                py: paddingY,
                borderRadius: 2,
                cursor: "pointer",
                bgcolor: "transparent",
                color: selected ? "#111" : "#6B7280",
                border: "1px solid transparent",
                transition: "color 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                zIndex: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              {opt.icon}
              <Typography
                sx={{
                  fontSize,
                  fontWeight: 600,
                  lineHeight: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {opt.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CustomMiddleSelect;
